
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire8a08"];
var parcelRegister = parcelRequire.register;
parcelRegister("8B2aV", function(module, exports) {

$parcel$export(module.exports, "VoximplantSupport", function () { return $64237761480395c3$export$835608f18338a31; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $iRxIj = parcelRequire("iRxIj");

var $iOlMk = parcelRequire("iOlMk");

var $lVvdy = parcelRequire("lVvdy");
const $64237761480395c3$var$SupportContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "VoximplantSupport__SupportContainer",
    componentId: "sc-fb121c-0"
})([
    'background:#C6007F;border-radius:12px;width:103px;height:40px;font-size:15px;display:flex;justify-content:center;align-items:center;position:fixed;bottom:5px;right:5px;z-index:50;color:white;font-weight:450;cursor:pointer;&:before{content:"";display:inline-block;position:relative;width:8px;height:8px;line-height:8px;margin-right:5px;border-radius:5px;vertical-align:.1em;box-shadow:0 0 0 1px hsla(0,0%,100%,.8);background-color:#51D161;background-image:-webkit-linear-gradient(left top,#80DC7A,#23C748);background-image:linear-gradient(to right bottom,#80DC7A,#23C748)}@media (max-width:768px){',
    ";right:20px;bottom:20px;}@media print{display:none;}"
], (props)=>props.showMobile ? "display: flex;" : "display: none;");
const $64237761480395c3$export$835608f18338a31 = (props)=>{
    const user = (0, $iRxIj.useStore)((0, $iOlMk.currentUser));
    const [isInitialized, setIsInitialized] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(()=>{
        (0, $lVvdy.setVoxCredentials)();
        if (!window.VoxKitWidget) {
            const script = document.createElement("script");
            script.textContent = `var l=function(){var t=function(){"object"==typeof VoxKitWidget&&"object"==typeof VoxKitWidgetSettings&&VoxKitWidget.init(VoxKitWidgetSettings)},e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src="https://kit.voximplant.com/static/widgets/web-chat.js?"+(new Date).valueOf(),e.readyState?e.onreadystatechange=function(){"loaded"!==e.readyState&&"complete"!==e.readyState||(e.onreadystatechange=null,t())}:e.onload=function(){t()};var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(e,a)};l();`;
            script.type = "text/javascript";
            document.getElementsByTagName("head")[0].appendChild(script);
        } else {
            window.VoxKitWidget.close();
            window.VoxKitWidget.destroy();
            window.VoxKitWidget.init(!user ? {
                ...window.VoxKitWidgetSettings,
                client_data: {
                    client_id: "",
                    // Customer ID
                    client_phone: "",
                    // Customer phone number
                    client_avatar: "",
                    // Customer avatar link
                    client_display_name: "",
                    // Customer name
                    client_email: "",
                    // Customer email
                    client_language: "ru" // Interface language: 'en' or 'ru'
                }
            } : window.VoxKitWidgetSettings);
        }
        setIsInitialized(true);
    }, [
        window.VoxKitWidgetSettings.client_data.client_display_name,
        user
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: isInitialized && /*#__PURE__*/ (0, $ih19M.jsx)($64237761480395c3$var$SupportContainer, {
            showMobile: props.showMobile,
            onClick: ()=>{
                if (!window.VoxKitWidget.isOpen) {
                    window.VoxKitWidget.open();
                    setTimeout(()=>{
                        var _document$getElements;
                        (_document$getElements = document.getElementsByClassName("editable")[0]) === null || _document$getElements === void 0 || _document$getElements.focus();
                    });
                } else window.VoxKitWidget.close();
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: "\u041F\u043E\u043C\u043E\u0449\u044C"
            })
        })
    });
};

});


//# sourceMappingURL=VoximplantSupport.3a29c224.js.map
